"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HIL_WELCOME_CALL_CALENDLY_URL = exports.AVEN_AFFILIATE_LEAD_CALENDLY_ID = exports.AVEN_AFFILIATE_LEAD_CALENDLY_URL = exports.AVEN_CONCIERGE_CALENDLY_ID = exports.AVEN_CONCIERGE_CALENDLY_URL = exports.CallMeNowReason = exports.LiveExpertEligibilityType = exports.PmlSegmentNameValues = exports.PmlSegmentName = exports.LIVE_EXPERT_BASE_DETAILS = exports.LiveExpert = void 0;
/** @TranslateToPython */
var LiveExpert;
(function (LiveExpert) {
    LiveExpert["PAUL_D"] = "paul-d";
    LiveExpert["RYAN_SALAM"] = "ryan-salam";
    LiveExpert["JOSH_HURLEY"] = "josh-hurley";
    LiveExpert["VERONIKA_BARBOSA"] = "veronika-barbosa";
    LiveExpert["PHILIP_ALAQHASH"] = "philip-alaqhash";
    LiveExpert["SANTIAGO_CORDOVEZ"] = "santiago-cordovez";
    LiveExpert["JAMES_MATEER"] = "james-mateer";
    LiveExpert["DAN_SALTER"] = "dan-salter";
    LiveExpert["DAVE_COOPER"] = "dave-cooper";
    LiveExpert["JULIA_BESERMAN"] = "julia-beserman";
})(LiveExpert || (exports.LiveExpert = LiveExpert = {}));
/** @TranslateToPython */
exports.LIVE_EXPERT_BASE_DETAILS = {
    [LiveExpert.PAUL_D]: {
        email: 'paul.doroshuk@aven.com',
        firstName: 'Paul',
        name: 'Paul D.',
        fullName: 'Paul Doroshuk',
        title: 'Sr. Aven Loan Officer',
        state: 'CA',
        nmls: '1999944',
        team: null,
        location: 'Campbell, California',
        locationShort: 'Campbell, CA',
        calendlyUrl: 'https://calendly.com/d/cxn8-8z9-cpj/aven-concierge-support',
    },
    [LiveExpert.RYAN_SALAM]: {
        email: 'aryan@aven.com',
        firstName: 'Ryan',
        name: 'Ryan S.',
        fullName: 'Ryan Salam',
        title: 'Director, Loan Officer',
        state: 'CA',
        nmls: '2252031',
        team: null,
        location: 'Campbell, California',
        locationShort: 'Campbell, CA',
        calendlyUrl: 'https://calendly.com/d/cxn8-8z9-cpj/aven-concierge-support',
    },
    [LiveExpert.JOSH_HURLEY]: {
        email: 'joshua.hurley@aven.com',
        firstName: 'Josh',
        name: 'Josh H.',
        fullName: 'Josh Hurley',
        title: 'Sr. Aven Loan Officer',
        state: 'UT',
        nmls: '2701270',
        team: null,
        location: 'Orem, Utah',
        locationShort: 'Orem, UT',
        calendlyUrl: 'https://calendly.com/d/cxn8-8z9-cpj/aven-concierge-support',
    },
    [LiveExpert.VERONIKA_BARBOSA]: {
        email: 'veronika.barbosa@aven.com',
        firstName: 'Veronika',
        name: 'Veronika B.',
        fullName: 'Veronika Barbosa',
        title: 'Refinance Specialist',
        state: null,
        nmls: null,
        team: 'Customer Concierge Team',
        location: null,
        locationShort: null,
        calendlyUrl: 'https://calendly.com/d/cvhm-n8t-gjm/aven-concierge-cardholder-support',
    },
    [LiveExpert.PHILIP_ALAQHASH]: {
        email: 'phillip.alaqhash@aven.com',
        firstName: 'Philip',
        name: 'Philip A.',
        fullName: 'Philip AlAqhash',
        title: 'Sr. Loan Officer',
        state: 'CA',
        nmls: '1777454',
        team: null,
        location: 'Campbell, California',
        locationShort: 'Campbell, CA',
        calendlyUrl: 'https://calendly.com/d/cxn8-8z9-cpj/aven-concierge-support',
    },
    [LiveExpert.SANTIAGO_CORDOVEZ]: {
        email: 'santiago.cordovez@aven.com',
        firstName: 'Sam',
        name: 'Sam C.',
        fullName: 'Sam Cordovez',
        title: 'Sr. Loan Officer',
        state: 'CA',
        nmls: '2751764',
        team: null,
        location: 'Campbell, California',
        locationShort: 'Campbell, CA',
        calendlyUrl: 'https://calendly.com/d/cxn8-8z9-cpj/aven-concierge-support',
    },
    [LiveExpert.JAMES_MATEER]: {
        email: 'james.mateer@aven.com',
        firstName: 'James',
        name: 'James M.',
        fullName: 'James Mateer',
        title: 'Sr. Aven Loan Officer',
        state: 'NC',
        nmls: '204624',
        team: null,
        location: null,
        locationShort: null,
        calendlyUrl: 'https://calendly.com/james-mateer-aven/loan-officer',
    },
    [LiveExpert.DAN_SALTER]: {
        email: 'daniel.salter@aven.com',
        firstName: 'Dan',
        name: 'Dan S.',
        fullName: 'Dan Salter',
        title: 'Senior Loan Officer',
        state: 'CA',
        nmls: '1407348',
        team: null,
        location: 'Campbell, California',
        locationShort: 'Campbell, CA',
        calendlyUrl: 'https://calendly.com/d/cxn8-8z9-cpj/aven-concierge-support',
    },
    [LiveExpert.DAVE_COOPER]: {
        email: 'dave.cooper@aven.com',
        firstName: 'Dave',
        name: 'Dave C.',
        fullName: 'Dave Cooper',
        title: 'Senior Loan Officer',
        state: 'CA',
        nmls: '403709',
        team: null,
        location: 'Campbell, California',
        locationShort: 'Campbell, CA',
        calendlyUrl: 'https://calendly.com/d/cxn8-8z9-cpj/aven-concierge-support',
    },
    [LiveExpert.JULIA_BESERMAN]: {
        email: 'julia.beserman@aven.com',
        firstName: 'Julia',
        name: 'Julia B.',
        fullName: 'Julia Beserman',
        title: 'Senior Loan Officer',
        state: 'CA',
        nmls: '1275212',
        team: null,
        location: 'Campbell, California',
        locationShort: 'Campbell, CA',
        calendlyUrl: 'https://calendly.com/d/cxn8-8z9-cpj/aven-concierge-support',
    },
};
var PmlSegmentName;
(function (PmlSegmentName) {
    PmlSegmentName["tracerPml980"] = "tracerPml980";
    PmlSegmentName["thirdLien980"] = "3rdLien980";
    PmlSegmentName["longTailRefi900"] = "longTailRefi900";
    PmlSegmentName["pml980"] = "pml980";
    PmlSegmentName["pml990"] = "pml990";
    PmlSegmentName["firstLienHlc990"] = "1stLienHlc990";
    PmlSegmentName["firstLienHlc900"] = "1stLienHlc900";
    PmlSegmentName["thirdLienPq980"] = "3rdLienPq980";
    PmlSegmentName["pq990"] = "pq990";
})(PmlSegmentName || (exports.PmlSegmentName = PmlSegmentName = {}));
// Pre-computed values for efficient lookup
exports.PmlSegmentNameValues = Object.values(PmlSegmentName);
var LiveExpertEligibilityType;
(function (LiveExpertEligibilityType) {
    LiveExpertEligibilityType["allHome"] = "allHome";
})(LiveExpertEligibilityType || (exports.LiveExpertEligibilityType = LiveExpertEligibilityType = {}));
var CallMeNowReason;
(function (CallMeNowReason) {
    CallMeNowReason["conciergeOG"] = "conciergeOG";
    CallMeNowReason["conciergeCH"] = "conciergeCH";
    CallMeNowReason["conciergeFirstLienOG"] = "conciergeFirstLienOG";
    // Routes the customer-initiated call to the MERCHANT_SUPPORT Amazon Connect queue so HIL ops
    // can complete the required welcome call before the customer draws funds.
    CallMeNowReason["hilWelcomeCall"] = "hilWelcomeCall";
})(CallMeNowReason || (exports.CallMeNowReason = CallMeNowReason = {}));
exports.AVEN_CONCIERGE_CALENDLY_URL = 'https://calendly.com/d/cxn8-8z9-cpj/aven-concierge-support';
exports.AVEN_CONCIERGE_CALENDLY_ID = 'ebdbc74b-20c7-4267-b572-6284116660a7';
// Round robin across the MLOs who work purchased affiliate leads; the booking's host claims the lead.
exports.AVEN_AFFILIATE_LEAD_CALENDLY_URL = 'https://calendly.com/d/dtvz-wjr-9pb/personalize-your-aven-heloc-offer';
exports.AVEN_AFFILIATE_LEAD_CALENDLY_ID = '0b3b2e61-93e4-45fa-a901-f7375bc48418';
exports.HIL_WELCOME_CALL_CALENDLY_URL = 'https://calendly.com/d/d3g4-7wn-n37/aven-partner-concierge-support';
